import React from 'react'
import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { notification, Button } from 'antd'
import { history } from 'index'
import BRAND from 'brand'
import * as firebase from 'services/firebase'
import { loginRedirectTarget } from 'services/redirect'
import actions from './actions'

const mapAuthProviders = {
  firebase: {
    login: firebase.login,
    loginWithGoogle: firebase.loginWithGoogle,
    // register: firebase.register,
    currentAccount: firebase.currentAccount,
    resetPassword: firebase.resetPassword,
    logout: firebase.logout,
  },
}

export function* RESET_PASSWORD({ payload }) {
  console.log('reset')
  console.log(payload)

  const { email } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider } = yield select(state => state.settings)
  yield call(mapAuthProviders[authProvider].resetPassword, email)
  notification.success({
    message: 'E-mail enviado',
    description:
      'Verifique sua caixa de entrada/spam e siga as instruções para redefinir sua senha.',
    key: 'emailsent',
  })
  yield history.push('/')
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGIN_WITH_GOOGLE() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider: autProviderName } = yield select(state => state.settings)
  const success = yield call(mapAuthProviders[autProviderName].loginWithGoogle)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    // honour a ?redirect= carried onto the login route by the layout guard
    yield history.push(loginRedirectTarget(history.location.search))
    notification.success({
      message: 'Log-in bem-sucedido',
      description: 'Sinta-se em casa!',
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* LOGIN({ payload }) {
  const { email, password } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider: autProviderName } = yield select(state => state.settings)
  const success = yield call(mapAuthProviders[autProviderName].login, email, password)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    // honour a ?redirect= carried onto the login route by the layout guard
    yield history.push(loginRedirectTarget(history.location.search))
    notification.success({
      message: 'Log-in bem-sucedido',
      description: 'Sinta-se em casa!',
      key: 'login',
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider } = yield select(state => state.settings)
  const response = yield call(mapAuthProviders[authProvider].currentAccount)
  if (response) {
    const { id, email, name, avatar, role, type, schools, location, modules, businessModels } =
      response
    yield put({
      type: 'user/SET_STATE',
      payload: {
        id,
        name,
        email,
        avatar,
        role,
        type,
        businessModels,
        schools,
        location,
        modules,
        authorized: true,
      },
    })

    if (['STUDENT', 'TEACHER'].includes(role)) {
      yield put({ type: 'user/LOGOUT' })
      notification.close('login')
      notification.error({
        message: 'Esse portal é exclusivo para gestores.',
        description: `Utilize o aplicativo da ${BRAND.name}`,
        duration: 0,
        btn: (
          <div className="w-100 d-flex align-items-start justify-content-start">
            <a href={BRAND.links.app}>
              <Button type="primary" htmlType="submit" className="mr-1">
                Acessar app da {BRAND.name}
              </Button>
            </a>
          </div>
        ),
      })
      return
    }

    if (!businessModels?.length) {
      yield put({ type: 'user/LOGOUT' })
      notification.close('login')
      notification.error({
        message: 'Nenhuma turma vinculada ao seu usuário.',
        description: `Entre em contato com o suporte da ${BRAND.links.supportName} para permitir seu acesso.`,
      })
      return
    }

    yield put({ type: 'groups/GET_DATA' })
    yield put({ type: 'schools/GET_DATA' })
    yield put({ type: 'configs/GET_DATA' })
    yield put({ type: 'cost-centers/GET_DATA' })
  }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT() {
  const { authProvider } = yield select(state => state.settings)
  yield call(mapAuthProviders[authProvider].logout)
  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: '',
      type: '',
      email: '',
      avatar: '',
      schools: [],
      businessModels: [],
      location: '',
      modules: [],
      authorized: false,
      loading: false,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.RESET_PASSWORD, RESET_PASSWORD),
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.LOGIN_WITH_GOOGLE, LOGIN_WITH_GOOGLE),
    // takeEvery(actions.REGISTER, REGISTER),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
